<template>
  <div class="custom-select" ref="select">
    <div class="selected-option" @click="isOpen = !isOpen">
      <span
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        "
      >
        <span style="display: flex; flex-direction: column">
          <span class="custom-label">Car type </span>
          <span class="select-text">
            {{ selectedOption }}
          </span>
        </span>
        <img
          src="@/assets/images/icons/interface-arrow-dropdown.png"
          :alt="`dropdown icon`"
        />
      </span>
    </div>
    <div class="options" v-show="isOpen">
      <div
        class="option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option, index)"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  data() {
    return {
      isOpen: false,
      selectedOption: this.value,
      selectedIndex: null,
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: null,
  },
  methods: {
    selectOption(option, index) {
      this.selectedOption = option;
      this.selectedIndex = index;
      this.isOpen = false;
      this.$emit("input", option);
    },
    handleClickOutside(event) {
      if (!this.$refs.select.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    this.selectedOption = this.selectedOption ? this.selectedOption : this.options[0];
    document.addEventListener("click", this.handleClickOutside);
  },
  watch: {
    value: function (val) {
      this.inputValue = val;
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.custom-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/2 */

  color: #5b626f;
}
.select-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/default */

  color: #30384a;
}
.custom-select {
  position: relative;
  background-color: #f6f6f4;
  height: 64px;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
}
.selected-option {
  background-color: #f6f6f4;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  cursor: pointer;
}
.options {
  position: absolute;
  max-height: 400px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05), 0px 4px 4px -1px rgba(0, 0, 0, 0.05),
    0px 12px 16px -8px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

.options::-webkit-scrollbar {
  display: none;
}
.option {
  padding: 10px;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
}
.option:hover {
  background: #f2f3f4;
}
</style>
